<template>
  <div class="bg-light py-4" style="min-height: 100vh;">
    <div class="container" v-if="schoolData">
      <div class="pt-1 pb-4">
        <div class="d-flex align-items-center justify-content-center mt-auto">
          <img v-if="schoolData.name" :src="schoolData.logo" :alt="schoolData.name" style="width:70px;" />
          <img v-else src="/resources/images/air-logo.png" alt="neoskool" />
          <div class="ml-3">
            <div class="h5 font-weight-bold text-dark mb-0">{{ schoolData.name ? schoolData.name : 'skoolsync-M'}}</div>
            <div
              class="font-size-12 text-gray-6"
            >{{ schoolData.contact ? `${schoolData.contact.address}, ${schoolData.contact.city}` : '' }}</div>
          </div>
        </div>
      </div>
      <a-divider />
      <div class="mt-3">
        <div class="air__utils__heading">
          <div class="row">
            <div class="col-sm-6">
              <h5>Online Fee Payment</h5>
            </div>
          </div>
        </div>
        <div>
          <div class="row justify-content-center my-4">
            <div class="col-12 text-center mb-3" v-if="!studentCode">
              <a-tag color="red" style="font-size: large">
                {{ message }}
              </a-tag>
            </div>
          </div>
        </div>
      </div>
      <pay-student-fees @paid="handleFeesPaid" :schoolData="schoolData"/>
      <student-fee-payment :is-public="true" :schoolData="schoolData"/>
      <hr>
      <div class="d-flex justify-content-center">
        <div class="col-sm-12 col-md-3">
          <h5> Contact Us</h5>
          <div class="fe fe-phone pt-2"> +91 {{schoolPrivacyPolicy.phone}}</div>
          <div class="fe fe-mail pt-2"> {{schoolPrivacyPolicy.email_id}}</div>
          <div class="fe fe-home pt-2"> {{schoolPrivacyPolicy.address}}</div>
        </div>
        <div class="col-sm-12 col-md-3">
          <ul>
            <li><a v-bind:href="schoolPrivacyPolicy.about_us" target="_blank">About Us</a></li>
            <li><a v-bind:href="schoolPrivacyPolicy.terms_and_conditions" target="_blank">Terms and Conditions</a></li>
            <li><a v-bind:href="schoolPrivacyPolicy.privacy_policy" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import PayStudentFees from '@/components/public/Fees/Pay/index'
import StudentFeePayment from '@/components/feemanagement/payment/Payment/index'

import { feeTypes } from '@/services/globaldata'
import { find } from 'lodash'

const subdomain = window.location.host.split('.')[0]

export default {
  name: 'FeePaymentFallbackPage',
  components: {
    PayStudentFees,
    StudentFeePayment,
  },
  mounted: function() {
    this.getSchoolData()
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
      selectedStudent: this.intialStudent,
      studentCode: this.$route.query.sc,
      schoolData: null,
      data: null,
      notFound: false,
      loading: false,
      schoolPrivacyPolicy: null,
    }
  },
  computed: {
    ...mapState(['settings']),
    message() {
      return this.$route.query.message || ''
    },
  },
  watch: {
    data(value) {
      this.$router.push({ name: 'publicpayfees', query: { sc: this.studentCode } })
    },
  },
  methods: {
    moment,
    find,
    getSchoolData: function() {
      this.loading = true
      this.$http.get(`/api/school/subdomain/${subdomain}`)
        .then(({ data }) => {
          this.loading = false
          if (data.data.online_payment) {
            this.schoolData = data.data
            this.getSchoolPrivacyPolicy()
            this.$nextTick(() => {
              if (this.$route.query.sc) {
                this.getStudentFees(this.$route.query.sc)
              }
            })
          } else {
            this.$router.push({ name: '404' })
          }
        })
    },
    getSchoolPrivacyPolicy: function() {
      this.loading = true
      this.$http.get(`api/school-privacy-policy/` + this.schoolData.id)
        .then(({ data }) => {
          this.loading = false
          if (data.data != null) {
            this.schoolPrivacyPolicy = data.data
          } else {
            this.$router.push({ name: '404' })
          }
        })
    },
  },
}
</script>
